<template>
  <div class="picker-apply-list">
    <div class="c-3 f-18 font-b p-b15 bg-f">提货清单</div>
    <el-row class="top flex-h-sb-ac p-lr20 m-b20 bg-gray c-6 f-12">
      <el-col :span="8" class="text-left"><span>货物信息</span></el-col>
      <el-col :span="6" class="text-center"><span>商家</span></el-col>
      <el-col :span="6" class="text-center"><span>订单编号</span></el-col>
      <el-col :span="4" class="text-right"><span>预提件数</span></el-col>
    </el-row>
    <el-row v-for="(item, i) in chooseData.depositoryOrderContexts" :key="i" class="section m-b20">
      <div class="c-3 f-12 flex-h-ac m-t20 p-l20">
        <img
          class="m-r5"
          src="@/assets/icons/cangku.svg"
          :style="{ width: '14px', height: '14px' }"
        />
        {{ item.depositoryName }}
      </div>
      <!-- cell -->
      <div v-for="(cell, j) in item.itemResultList" :key="j" class="cell flex-h-sb p-20">
        <el-col :span="8">
          <zg-cell
            :name="cell.productTitle"
            :supplier-name="cell.supplierName"
            :desc="cell.skuTitle || cell.productSubTitle"
            :img-src="cell.icon"
          ></zg-cell>
        </el-col>
        <el-col :span="6" class="f-12 text-center">
          <span class="underline">{{ cell.sellerOrgName }}</span>
        </el-col>
        <el-col :span="6" class="f-12 text-center">
          <span class="underline">{{ cell.orderId }}</span>
        </el-col>
        <el-col :span="4" class="text-right">
          <span class="c-9 f-13 m-r20">预提:</span>
          <span class="c-3 f-13">
            {{ cell.preProductNum }}{{ cell.weightUnitValue | exUnit(true) }}
            {{ cell.preProductWeight | formatWeightWithUnitFix(cell.weightUnitValue) }}
          </span>
        </el-col>
      </div>
      <div class="bottom flex-h-sb-ac p-20">
        <div class="left"></div>
        <div class="right">
          <span class="c-9 f-13 m-r20">小计:</span>
          <span class="c-3 f-13"
            >{{ item.preProductNum }}件 {{ item.preProductWeight | formatWeightWithUnitFix }}</span
          >
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import ZgCell from '@/components/zg-cell'

export default {
  name: 'PickerApplyList',
  components: { ZgCell },
  props: {
    chooseData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.picker-apply-list {
  .top {
    height: 45px;
    .link:hover {
      color: #d0111a;
    }
  }
  .section {
    border: 2px solid #f5f7fa;
    border-top: 1px solid #cccccc;
    .cell {
      border-bottom: 2px solid #f5f7fa;
    }
    .bottom {
    }
  }
}
</style>
